"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbGuidePlaceTransportView = void 0;
var React = require("react");
var DbGuideSliderView_1 = require("@/pages/dbguide/components/DbGuideSliderView");
exports.DbGuidePlaceTransportView = function (props) {
    var onBackClick = function () { return props.onBackClick(); };
    var onRouteClick = function (row) { return function () { return props.onRouteClick(row); }; };
    var renderRouteRow = function (row, i) { return (React.createElement("tr", { key: i },
        React.createElement("td", { style: { width: '100px' } }, row.name),
        React.createElement("td", null,
            React.createElement("a", { onClick: onRouteClick(row), href: "#" }, row.routeName)),
        React.createElement("td", null,
            React.createElement("a", { target: "_blank", href: row.scheduleLink }, "Schedule")))); };
    var renderAppSection = function (props) {
        var renderAndroid = function (link) { return (React.createElement("a", { className: "c-guides__app", href: link },
            React.createElement("img", { src: "https://ww2.okay.com/search/map/images/getandroidapp.png", alt: "" }))); };
        var renderIos = function (link) { return (React.createElement("a", { className: "c-guides__app", href: link },
            React.createElement("img", { src: "https://ww2.okay.com/search/map/images/getiosapp.jpg", alt: "" }))); };
        return props.app ? (React.createElement("div", { className: "c-guides__section" },
            React.createElement("div", { className: "c-guides__text" }, props.app.text),
            React.createElement("div", { className: "c-guides__apps" },
                props.app.android ? renderAndroid(props.app.android) : '',
                props.app.ios ? renderIos(props.app.ios) : ''))) : '';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "c-guides__nav" },
            React.createElement("div", { onClick: onBackClick, id: "back", className: "c-guides__back" },
                React.createElement("span", { className: "fas fa-chevron-left" })),
            React.createElement("div", { className: "c-guides__title" }, props.name),
            React.createElement("div", { className: "c-guides__done" })),
        React.createElement("div", { className: "c-guides__body" },
            React.createElement("div", { className: "c-guides__section" },
                React.createElement(DbGuideSliderView_1.DbGuideSliderView, { photos: props.photos, onSliderNextClick: props.onSliderNextClick, onSliderPrevClick: props.onSliderPrevClick }),
                React.createElement("div", { className: "c-guides__text" }, props.description)),
            React.createElement("div", { className: "c-guides__section" },
                React.createElement("div", { className: "c-guides__table" },
                    React.createElement("table", null,
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, props.name),
                                React.createElement("th", null, "Route"),
                                React.createElement("th", null, "Schedule")),
                            props.routes.map(renderRouteRow))))),
            renderAppSection(props))));
};
